/**
 * Etiquetas en español para tipos de sensor VSaaS (claves técnicas del API / Timescale).
 * Mismo criterio y textos que forensic-reconstruction-ui (lang/es/ProjectSettings.sensorTypes).
 */

export const SENSOR_TYPE_LABELS_ES = {
  BeaconTracking: 'Seguimiento beacon',
  Boolean: 'Booleano',
  CargoContainerISOReader: 'Lector ISO de contenedor',
  Checkout: 'Checkout',
  ColorPresence: 'Presencia de color',
  ConcentrationAlert: 'Alerta de concentración',
  CrossLineMultiRecognition: 'Reconocimiento multi línea',
  CrossLineRecognition: 'Reconocimiento de línea',
  CrossedBarriersDetection: 'Detección de barreras cruzadas',
  Debug: 'Debug',
  FaceDetection: 'Detección facial',
  FaceMaskDetection: 'Detección de mascarilla',
  FaceRecognition: 'Reconocimiento facial',
  FuelingDetection: 'Detección de combustible',
  GPS: 'GPS',
  GranularityDetection: 'Detección de granularidad',
  Heatmap: 'Mapa de calor',
  LicensePlate: 'Patente',
  LicensePlateText: 'Texto de patente',
  LineCrossingDetection: 'Cruce de línea',
  MissingHelmetDetection: 'Casco faltante',
  MotionDetection: 'Detección de movimiento',
  MultiLineCrossingDetection: 'Cruce multi línea',
  MultiZoneObjectTracking: 'Seguimiento multi zona',
  NaiveSocialDistancing: 'Distancia social',
  NoPlateDetection: 'Sin patente',
  Number: 'Número',
  ObjectCounting: 'Conteo de objetos',
  ObjectRecognition: 'Reconocimiento de objetos',
  ObjectRecognitionNumeric: 'Reconocimiento numérico',
  OpeningDetection: 'Detección de apertura',
  OpticalCharacterRecognition: 'OCR',
  OverlapDetection: 'Detección de solapamiento',
  PanicButton: 'Botón de pánico',
  PeriodicObjectCounting: 'Conteo periódico',
  PoseDetection: 'Detección de pose',
  QueueSize: 'Tamaño de fila',
  Referrer: 'Referrer',
  SceneChange: 'Cambio de escena',
  ShoppingHours: 'Horario comercial',
  SpeedChange: 'Cambio de velocidad',
  StoppedLicensePlate: 'Patente detenida',
  StoppedObjectsDetector: 'Objetos detenidos',
  String: 'Texto',
  Video: 'Video',
};

/** Devuelve la etiqueta legible del tipo de sensor, o la clave original si no hay traducción. */
export function formatSensorTypeLabel(sensorType, labels = SENSOR_TYPE_LABELS_ES) {
  const key = String(sensorType ?? '').trim();
  if (!key) return '';
  return labels[key] || key;
}
